module.exports = __webpack_public_path__ + "static/media/drive-2.be8cbd26.jpeg";